import { ZipCode as ZipCodeValidation } from '@hc-frontend/core-types';
import {
  ErrorMessage,
  Input,
  PhoneInput,
  Select,
  TextInput,
  ZipCodeInput,
} from '@hc-frontend/core-ui';
import { ButtonWithTracking } from '@hc-frontend/shells-shared';
import React, { type ChangeEvent, useState } from 'react';
import type { FieldErrors, UseFormRegister } from 'react-hook-form';

import type { FormState, UserInputs } from './constants';
import { FieldNames } from './constants';

export default function FormContent({
  register,
  clientErrors,
  state,
  isPending,
}: {
  register: UseFormRegister<UserInputs>;
  clientErrors: FieldErrors<UserInputs>;
  state: FormState;
  isPending: boolean;
}) {
  const [zipCode, setZipCode] = useState('');
  const [isZipCodeValid, setIsZipCodeValid] = useState(false);
  const handleZipCodeChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    setZipCode(value);
    setIsZipCodeValid(ZipCodeValidation.safeParse(value).success);
  };
  const isSubmitButtonDisabled = !isZipCodeValid;

  return (
    <>
      <Select
        label="Inquiry"
        name={FieldNames.CASE_TYPE}
        disabled={isPending}
        options={[
          {
            id: 'ccpa-info-req',
            label: 'Right to know what information is collected',
          },
          {
            id: 'ccpa-delete-req',
            label: 'Right to delete personal information',
          },
          {
            id: 'ccpa-opt-out-sales-req',
            label: 'Right to opt-out of sales of my personal information',
          },
        ]}
      />
      <div
        className="hc-grid-layout delay-300 duration-1000"
        style={{
          '--hc-grid-layout-width-breakpoint': '220px',
        }}
      >
        <TextInput
          label="First Name"
          placeholder="First name"
          required
          disabled={isPending}
          {...register(FieldNames.FIRST_NAME)}
          errorText={
            <ErrorMessage>
              {clientErrors[FieldNames.FIRST_NAME]?.message}
            </ErrorMessage>
          }
        />
        <TextInput
          label="Last Name"
          placeholder="Last name"
          required
          disabled={isPending}
          {...register(FieldNames.LAST_NAME)}
          errorText={
            <ErrorMessage>
              {clientErrors[FieldNames.LAST_NAME]?.message}
            </ErrorMessage>
          }
        />
      </div>
      <Input
        label="Email"
        placeholder="Email"
        required
        disabled={isPending}
        type="email"
        {...register(FieldNames.EMAIL)}
        errorText={
          <ErrorMessage>{clientErrors[FieldNames.EMAIL]?.message}</ErrorMessage>
        }
        error={!!clientErrors[FieldNames.EMAIL]?.message}
      />
      <ZipCodeInput
        label="Zip Code"
        name={FieldNames.ZIP_CODE}
        placeholder="Enter Zip Code"
        disabled={isPending}
        withButton={false}
        value={zipCode}
        onChange={handleZipCodeChange}
      />
      <PhoneInput
        label="Phone Number"
        placeholder="(___) ___-____"
        required
        disabled={isPending}
        {...register(FieldNames.PHONE_NUMBER)}
        errorText={
          <ErrorMessage>
            {clientErrors[FieldNames.PHONE_NUMBER]?.message}
          </ErrorMessage>
        }
      />
      <div className="text-center">
        <ErrorMessage>{state._errors}</ErrorMessage>
      </div>

      <div className="text-center">
        <ButtonWithTracking
          id="submit"
          variant="primary-card"
          type="submit"
          className="px-32-60"
          metricTags={{}}
          disabled={isPending || isSubmitButtonDisabled}
          name="action"
          value="continue"
        >
          Submit
        </ButtonWithTracking>
      </div>
    </>
  );
}
